import * as React from 'react';

const SlackIcon$2 = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E01E5A",
        d: "M4.8 12.38a1.89 1.89 0 1 1-1.9-1.9h1.9zm.94 0a1.89 1.89 0 1 1 3.78 0v4.73a1.89 1.89 0 1 1-3.78 0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#36C5F0",
        d: "M7.63 4.78A1.89 1.89 0 1 1 9.52 2.9v1.9zm0 .96a1.89 1.89 0 1 1 0 3.79H2.89a1.89 1.89 0 1 1 0-3.79z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#2EB67D",
        d: "M15.2 7.64a1.89 1.89 0 1 1 1.9 1.89h-1.9zm-.94 0a1.89 1.89 0 1 1-3.78 0V2.89a1.89 1.89 0 1 1 3.78 0z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#ECB22E",
        d: "M12.37 15.22a1.89 1.89 0 1 1-1.89 1.89v-1.9zm0-.95a1.89 1.89 0 1 1 0-3.78h4.74a1.89 1.89 0 1 1 0 3.78z"
    }));

export { SlackIcon$2 as SlackIcon };
//# sourceMappingURL=Slack.mjs.map
